<template>
  <div class="wrapper height100">
    <div v-if="loading" class="d-flex align-center height100">
      <vue-loading
        loader="bars"
        color="#EE6090"
        :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
    <v-container v-else fluid class="height100">
      <v-form class="pt-5">
        <div>
        <p>本画面は、園児との初回登録時に表示される画面です。</p>
        <br />
        <p>過去にCCSHOMEをご利用いただいたことがある場合、初回登録時とは異なるメールアドレスでログインしようとしています。</p>
        <p>一度ログアウトをタップし、初回登録時に使用したアカウント、ログイン方法でログインしてください。</p>
        <br />
        <p>初めて登録される方は、下記に案内状に記載のお子様IDおよびパスワードをご入力ください。</p>
        <br />
        </div>
        <div>
          <p class="body-2 blue-grey--text">お子様のID</p>
          <v-text-field
            v-model="postFamilyRequest.childCode"
            outlined
            dense></v-text-field>
        </div>

        <div>
          <p class="body-2 blue-grey--text">パスワード</p>
          <v-text-field
            v-model="postFamilyRequest.password"
            outlined
            dense
            type="password"></v-text-field>
        </div>

        <div>
          <p class="body-2 blue-grey--text">保護者タイプ</p>
          <v-select
            v-model="postFamilyRequest.parentType"
            :items="parentTypes"
            item-title="text"
            item-value="value" outlined
            dense
          ></v-select>
        </div>

        <div class="d-flex justify-center my-5">
          <v-btn
            @click="postFamily"
            :loading="btnLoading"
            color="primary"
            block>
            送信
          </v-btn>
        </div>

        <div>
          <v-btn @click="logout" color="primary" outlined block>
            ログアウト
          </v-btn>
        </div>
      </v-form>
    </v-container>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import { familyModule } from '@/store/entityModules/family';
import { auth0Module } from '@/store/entityModules/auth0';

// model
import { PostFamilyRequest } from '@/model/Family';

import parentTypes from '@/service/parentTypes';

interface DataType {
  postFamilyRequest: PostFamilyRequest;
  btnLoading: boolean;
}

export default defineComponent({
  components: {
    'vue-loading': Loading,
  },

  data: () => ({
    loading: true,
    btnLoading: false,
    postFamilyRequest: {
      childCode: '',
      password: '',
      parentType: '',
    },
  }),

  computed: {
    parentTypes() {
      return parentTypes;
    },
  },

  methods: {
    async postFamily() {
      try {
        this.btnLoading = true;
        const response = await familyModule.postFamily(this.postFamilyRequest);
        if (response) {
          this.$router.push('/home');
          this.btnLoading = false;
        }
      } catch (error) {
        this.btnLoading = false;
      }
    },
    logout() {
      auth0Module.logout();
    },
  },

  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 3000);
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: calc(env(safe-area-inset-top));
    margin-bottom: calc(env(safe-area-inset-bottom));
  }
}
</style>
